/* Sidebar Panels JavaScript/jQuery */
jQuery(function( $ ) {

    window.vmNotificationManager = new Vue({
        el: '#v-notifications',
        data: {
			id: 0, // iterator for generating unique notification ids
			notifications: [], // array of existing notifications
			hideNotificationsFlag: false, // flag
        },
        methods: {
			hideNotifications: function() {
				this.hideNotificationsFlag = true;
			},
			showNotifications: function() {
				this.hideNotificationsFlag = false;
			},
			addInfoNotification: function( message, timeout = undefined ) {
				message = null == message ? "Connecting to Server" : message;
				// WEBCITZ REMOVED return this.addNotification( message, 'info', timeout || 5000 );
            },
			addSuccessNotification: function( message, timeout = undefined ) {
				message = null == message ? "Operation Successful" : message;
				// WEBCITZ REMOVED return this.addNotification( message, 'success', timeout || 5000 );
            },
            addErrorNotification: function( message, timeout = undefined ) {
				message = null == message
					? "An error occured while trying to connect to the server. Please <a href='javascript:location.reload(true)'>refresh&nbsp;this&nbsp;page</a>"
					: message;
				return this.addNotification( message, 'error', timeout || 60 * 1000 );
			},
            removeNotification: function( id ) {
                this.notifications = this.notifications.filter( notificaton => notificaton.id != id );
            },
			// intended for private calls
			addNotification: function( message, type, timeout ) {
				if ( this.hideNotificationsFlag ) {
					return;
				}

				let notificationId = this.id++;
				let removeCallback = this.removeNotification;


				type = type ? type : 'info';
				timeout = timeout ? timeout : 10 * 1000;

				this.notifications.push( { message: message, type: type, id: notificationId } );

				setTimeout( removeCallback, timeout, notificationId );

				return notificationId;
			}
        }
    });

});
